import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import titleize from 'titleize'

import { showMoreThreshold } from './utils'
import { commaStyleString } from '../../../../common/utils/formatString'

const MultiSelectPanelBody = (props) => {
  const {
    selectedOption,
    type,
    items,
    isExpandable,
    isExpanded,
    onSelectOption
  } = props

  const listClassNames = classNames(
    'search-facet-multi-select-in-panel', {
      'is-expanded': isExpanded && isExpandable
    }
  )

  const highestCount = items.map((item) => {
    return item.count
  }).reduce((pre, cur) => {
    return pre > cur ? pre : cur
  }, 0)

  // calculate the width of the category based on the count
  const calcWidthPercentage = (count) => {
    let percentage = count / highestCount * 100
    return percentage.toFixed(2)
  }

  const renderList = (item, idx) => {
    // grep the last part of the chose category
    const displayName = item.label || titleize(item.key)
    const listClassName = classNames(
      'search-facet-multi-select-panel__option', {
        'is-active': selectedOption.split(',').indexOf(item.key) >= 0,
        // only apply fds-u-is-hidden class when the list is expanded and has more than 10 items
        'fds-u-is-hidden': !isExpanded && idx >= showMoreThreshold[type]
      }
    )

    const linkStyle = {
      minWidth: '50%',
      width: `calc(${calcWidthPercentage(item.count)}% - 30px)`
    }

    const labelClassName = classNames({
      'search-panel-facet-colours__link': type === 'colors',
      [`-color-${item.key}`]: type === 'colors'
    })

    const onClickHandler = (e) => {
      e.preventDefault()
      onSelectOption(item.key)
    }

    return (
      <li key={idx} className={listClassName}>
        <label className={labelClassName} onClick={onClickHandler}>
          <div className='search-facet-multi-select-panel__title' style={linkStyle}>
            <div className='search-facet-multi-select-panel__title-inner'>
              {displayName}
            </div>
          </div>
          <div className='search-facet-multi-select-panel__count'>
            {commaStyleString(item.count)}
          </div>
          <div className='search-facet-multi-select-panel__status'>
            <div>
              <i className='e-icon -icon-ok'><span className='e-icon__alt'>selection active</span></i>
            </div>
            <div>
              <i className='e-icon -icon-cancel'><span className='e-icon__alt'>remove selection</span></i>
            </div>
          </div>
          <input name={`${type}[]`} type='checkbox' value={item.key} />
        </label>
      </li>
    )
  }

  // show category list if there are more than 0 item in the list
  if (items && items.length > 0) {
    return (
      <ul className={listClassNames}>
        {items.map((item, idx) => {
          return renderList(item, idx)
        })}
      </ul>
    )
  // if there's no more category to show, show the ran out of categoreis section
  } else {
    return (
      <div className='search-facet-panel__more-results'>
        <p className='fds-c-text-body fds-u-mt4'>
          Sorry, we ran out of option :)
        </p>
      </div>
    )
  }
}

MultiSelectPanelBody.propTypes = {
  type: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  parsedLocation: PropTypes.object.isRequired,
  selectedOption: PropTypes.string.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isExpandable: PropTypes.bool.isRequired,
  onSelectOption: PropTypes.func.isRequired
}

export default MultiSelectPanelBody



// WEBPACK FOOTER //
// ./client/components/filters/filtersPanel/multiSelectPanelBody.js